/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import jMoment from 'moment-jalaali'
import Select from 'react-select'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SECURITY from '../BaseComponent/SECURITY'
import USER_REPORT from '../BaseComponent/USERREPORT'
import cookie from 'react-cookies'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import TMS from '../BaseComponent/TMS'

class Operators extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      Drivers: [],
      printInfo: [],
      modalActivate: false,
      modalBlock: false,
      modalReset: false,
      modalDelete: false,
      modalRole: false,
      roleCategorys: [],
      rolesArr: [],
      roles: [],
      roleIdStatus: '',
      modalSection: false,
      sections: [],
      userSections: [],
      secArr: [],
      process: [],
      selectedProcess: []
    }
  }

  fetchOperators(role) {
    sessionStorage.setItem('roleId', role)
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    http
      .get(USER_REPORT.USER_REPORT_OPERATOR + '?export=false' + '&pageSize=10' + '&pageNumber=1' + `&roleId=${role}`)
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            Drivers: response.data.object.result,
            DriversCount: response.data.object.countAll
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    this.fetchOperators(this.props.match.params.role || '')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.role !== nextProps.match.params.role) {
      // console.log('update')
      this.fetchOperators(nextProps.match.params.role || '')
      return false
    }
  }

  openActivate = (num) => {
    this.setState({
      modalActivate: !this.state.modalActivate
    })
    sessionStorage.setItem('personId', this.state.Drivers[num].personId)

    if (this.state.Drivers[num].active) {
      sessionStorage.setItem('active', 'activate')
    } else {
      sessionStorage.setItem('active', 'deActivate')
    }
  }
  toggleActivate = () => {
    this.setState({
      modalActivate: !this.state.modalActivate
    })
    sessionStorage.removeItem('personId')
    sessionStorage.removeItem('active')
  }
  cancelActivate = () => {
    sessionStorage.removeItem('personId')
    sessionStorage.removeItem('active')
    this.setState({
      modalActivate: !this.state.modalActivate
    })
  }

  ConfirmActivate() {
    var personId = sessionStorage.getItem('personId')
    let getPersonStatus = sessionStorage.getItem('active')
    if (getPersonStatus == 'activate') {
      let reason = '1'
      let data = {
        personId: personId,
        reasonId: reason
      }
      const token = sessionStorage.getItem('accessToken')

      http
        .post(`${USER_MANAGE.USER_MANAGE_DEACTIVATE}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            http
              .get(`${USER_REPORT.USER_REPORT_OPERATOR}?export=true`, {})
              .then((response) => {
                if (response.data.error == null) {
                  this.setState({
                    printInfo: response.data.object.result
                  })
                }
              })
              .catch((error) => {
                alert(JSON.stringify(error))
              })
            this.setState({
              modalActivate: !this.state.modalActivate
            })
            message.success('عملیات تغییر وضعیت کاربر با موفقیت انجام شد')
            this.fetchOperators(this.props.match.params.role || '')
          } else {
            this.setState({
              modalActivate: !this.state.modalActivate
            })
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else if (getPersonStatus == 'deActivate') {
      let reason = '1'
      let data = {
        personId: personId,
        reasonId: reason
      }
      const token = sessionStorage.getItem('accessToken')
      // alert(JSON.stringify(data))

      http
        .post(`${USER_MANAGE.USER_MANAGE_ACTIVATE}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            http
              .get(`${USER_REPORT.USER_REPORT_OPERATOR}?export=true`, {})
              .then((response) => {
                if (response.data.error == null) {
                  this.setState({
                    printInfo: response.data.object.result
                  })
                }
              })
              .catch((error) => {
                alert(JSON.stringify(error))
              })
            this.setState({
              modalActivate: !this.state.modalActivate
            })
            message.success('عملیات تغییر وضعیت کاربر با موفقیت انجام شد')
            this.fetchOperators(this.props.match.params.role || '')
          } else {
            this.setState({
              modalActivate: !this.state.modalActivate
            })
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  openBlock = (num) => {
    this.setState({
      modalBlock: !this.state.modalBlock
    })

    sessionStorage.setItem('personId', this.state.Drivers[num].personId)
    if (this.state.Drivers[num].block) {
      sessionStorage.setItem('block', 'activate')
    } else {
      sessionStorage.setItem('block', 'deActivate')
    }
  }

  toggleBlock = () => {
    this.setState({
      modalBlock: !this.state.modalBlock
    })
  }

  cancelBlock = () => {
    sessionStorage.removeItem('personId')
    sessionStorage.removeItem('block')
    this.setState({
      modalBlock: !this.state.modalBlock
    })
  }

  ConfirmBlock() {
    var personId = sessionStorage.getItem('personId')
    let getPersonStatusBlock = sessionStorage.getItem('block')
    if (getPersonStatusBlock == 'activate') {
      let reason = '1'
      let data = {
        personId: personId,
        reasonId: reason
      }
      const token = sessionStorage.getItem('accessToken')

      http
        .post(`${USER_MANAGE.USER_MANAGE_UNBLOCK}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            http
              .get(`${USER_REPORT.USER_REPORT_OPERATOR}?export=true`, {})
              .then((response) => {
                if (response.data.error == null) {
                  this.setState({
                    printInfo: response.data.object.result
                  })
                }
              })
              .catch((error) => {
                alert(JSON.stringify(error))
              })
            this.setState({
              modalBlock: !this.state.modalBlock
            })
            message.success('عملیات تغییر وضعیت بلاک کاربر با موفقیت انجام شد')
            this.fetchOperators(this.props.match.params.role || '')
          } else {
            this.setState({
              modalActivate: !this.state.modalActivate
            })
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else if (getPersonStatusBlock == 'deActivate') {
      let reason = '1'
      let data = {
        personId: personId,
        reasonId: reason
      }
      const token = sessionStorage.getItem('accessToken')
      // alert(JSON.stringify(data))

      http
        .post(`${USER_MANAGE.USER_MANAGE_BLOCK}`, data, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            http
              .get(`${USER_REPORT.USER_REPORT_OPERATOR}?export=true`, {})
              .then((response) => {
                if (response.data.error == null) {
                  this.setState({
                    printInfo: response.data.object.result
                  })
                }
              })
              .catch((error) => {
                alert(JSON.stringify(error))
              })
            this.setState({
              modalBlock: !this.state.modalBlock
            })
            message.success('عملیات تغییر وضعیت بلاک کاربر با موفقیت انجام شد')
            this.fetchOperators(this.props.match.params.role || '')
          } else {
            this.setState({
              modalActivate: !this.state.modalActivate
            })
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  openReset = (num) => {
    this.setState({
      modalReset: !this.state.modalReset
    })
    sessionStorage.setItem('personId', this.state.Drivers[num].personId)
    sessionStorage.setItem('fullName', this.state.Drivers[num].firstname + ' ' + this.state.Drivers[num].lastname)
  }

  toggleReset = () => {
    this.setState({
      modalReset: !this.state.modalReset
    })
  }

  cancelReset = () => {
    this.setState({
      modalReset: !this.state.modalReset
    })
    sessionStorage.removeItem('fullName')
  }
  confirmReset = () => {
    var personId = sessionStorage.getItem('personId')
    var password = document.getElementById('password').value
    if (password == '') {
      message.error('کلمه عبور جدید را وارد کنید')
    } else {
      let data = {
        personId: personId,
        password: password
      }

      http
        .post(`${USER_MANAGE.USER_MANAGE_EDIT_PASSWORD}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            message.success('تغییر کلمه عبور با موفقیت انجام شد')
            this.setState({
              modalReset: !this.state.modalReset
            })
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
            this.setState({
              modalReset: !this.state.modalReset
            })
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  deleteDriver = (num) => {
    let personId = this.state.Drivers[num].personId
    sessionStorage.setItem('personId', personId)
    sessionStorage.setItem('fullName', this.state.Drivers[num].firstname + ' ' + this.state.Drivers[num].lastname)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }

  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('personId')
    sessionStorage.removeItem('fullName')
  }

  deleteOk = () => {
    const token = sessionStorage.getItem('accessToken')
    let reason = '1'
    let personId = sessionStorage.getItem('personId')
    let data = {
      personId: personId,
      reasonId: reason
    }
    http
      .post(`${USER_MANAGE.USER_MANAGE_DELETE}`, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        if (response.data.error == null && response.data.object == 'SUCCESS') {
          http
            .get(`${USER_REPORT.USER_REPORT_OPERATOR}?export=true`, {})
            .then((response) => {
              if (response.data.error == null) {
                this.setState({
                  printInfo: response.data.object.result
                })
              }
            })
            .catch((error) => {
              alert(JSON.stringify(error))
            })

          this.fetchOperators(this.props.match.params.role || '')

          message.success('اپراتور با موفقیت حذف شد')

          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  handleChange = (roleCategorys) => {
    var wareCode = []
    this.setState({roleCategorys})

    // alert(JSON.stringify(selectedOption))
    console.log(`Option selected:`, roleCategorys)

    for (let prop of roleCategorys) {
      wareCode.push(prop.id)
      this.setState({
        rolesArr: wareCode
      })
      sessionStorage.setItem('wareCode', JSON.stringify(wareCode))
    }
  }

  openEditRole = (num) => {
    let personId = this.state.Drivers[num].personId
    sessionStorage.setItem('personId', personId)
    sessionStorage.setItem('fullName', this.state.Drivers[num].firstname + ' ' + this.state.Drivers[num].lastname)
    this.setState({
      modalRole: !this.state.modalRole
    })
    http.get(`${SECURITY.SECURITY_MANAGE_LIST_ROLE}?containNonOperator=false`, {}).then((response) => {
      if (response.data.errror == null) {
        var result = response.data.object
        for (let i = 0; i < result.length; i++) {
          result[i]['value'] = result[i].id
          result[i]['label'] = result[i].title
        }
        this.setState({
          roles: response.data.object
        })
      }
    })
    http.get(`${USER_MANAGE.USER_MANAGE_LIST_ROLE}?personId=${personId}`, {}).then((response) => {
      if (response.data.error == null) {
        let object = response.data.object
        for (let i = 0; i < object.length; i++) {
          object[i]['value'] = object[i].id
          object[i]['label'] = object[i].title
        }
        this.setState({
          roleCategorys: response.data.object
        })
        var wareCode = []

        for (let prop of this.state.roleCategorys) {
          wareCode.push(prop.id)
          this.setState({
            rolesArr: wareCode
          })
          sessionStorage.setItem('wareCode', JSON.stringify(wareCode))
        }
      }
    })
  }

  cancelRole = () => {
    this.setState({
      modalRole: !this.state.modalRole
    })
  }

  editRole = () => {
    let personId = sessionStorage.getItem('personId')
    let data = {
      personId: personId,
      roleIds: this.state.rolesArr
    }
    if (this.state.roleCategorys.length == '0') {
      message.error('حداقل یک نقش وارد شود')
    } else {
      http.post(`${USER_MANAGE.USER_MANAGE_EDIT_ROLE}`, data, {}).then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          message.success('نقش کاربر ویرایش شد')
          this.setState({
            modalRole: !this.state.modalRole
          })
          // alert(JSON.stringify(response.data))
        }
      })
    }
  }

  openEditProcess = (num) => {
    let personId = this.state.Drivers[num].personId
    sessionStorage.setItem('personId', personId)
    sessionStorage.setItem('fullName', this.state.Drivers[num].firstname + ' ' + this.state.Drivers[num].lastname)
    this.setState({
      modalProcess: !this.state.modalProcess
    })
    http
      .get(`process/list`, {})
      .then((res) => {
        if (res.data.error === null) {
          let process = res.data.object
          process.forEach((item) => {
            item.value = item.id
            item.label = item.title
          })
          this.setState(
            {
              process
            },
            () => {
              http
                .get(`user/manage/list/process?personId=${personId}`, {})
                .then((res) => {
                  if (res.data.error === null) {
                    let {process} = this.state
                    let selectedProcess = []
                    process.forEach((item) => {
                      res.data.object.forEach((ch) => {
                        if (ch.id === item.id) {
                          selectedProcess.push(item)
                        }
                      })
                    })
                    this.setState({
                      selectedProcess
                    })
                  }
                })
                .catch(() => {})
            }
          )
        }
      })
      .catch(() => {})
  }

  changeOperatorProcess = (selectedProcess) => {
    this.setState({
      selectedProcess
    })
  }

  editProcess = () => {
    let processIds = []
    this.state.selectedProcess.forEach((item) => {
      processIds.push(item.id)
    })
    let personId = sessionStorage.getItem('personId')

    let model = {
      processIds,
      personId
    }
    http
      .post(`user/manage/edit/process`, model, {})
      .then((res) => {
        if (res.data.error == null) {
          message.success('فرایند کاربر ویرایش شد')
          this.setState({
            modalProcess: !this.state.modalProcess
          })
        }
      })
      .catch(() => {})
  }

  openEditSection = (num) => {
    let personId = this.state.Drivers[num].personId
    sessionStorage.setItem('personId', personId)
    sessionStorage.setItem('fullName', this.state.Drivers[num].firstname + ' ' + this.state.Drivers[num].lastname)
    this.setState({
      modalSection: true
    })
    http.get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}`, {}).then((response) => {
      if (response.data.errror == null) {
        var result = response.data.object
        for (let i = 0; i < result.length; i++) {
          result[i]['value'] = result[i].id
          result[i]['label'] = result[i].departmentTitle + ' - ' + result[i].title
        }
        this.setState({
          sections: response.data.object
        })
      }
    })

    http.get(`${USER_MANAGE.USER_MANAGE_LIST_TMS_SECTION}?personId=${personId}`, {}).then((response) => {
      if (response.data.error == null) {
        let object = response.data.object
        for (let i = 0; i < object.length; i++) {
          object[i]['value'] = object[i].id
          object[i]['label'] = object[i].title
        }
        this.setState({
          userSections: response.data.object
        })
        var wareCode = []

        for (let prop of this.state.userSections) {
          wareCode.push(prop.id)
          this.setState({
            secArr: wareCode
          })
          sessionStorage.setItem('wareCode', JSON.stringify(wareCode))
        }
      }
    })
  }
  cancelSection = () => {
    this.setState({
      modalSection: false
    })
  }
  editSectionOk = () => {
    let personId = sessionStorage.getItem('personId')
    let data = {
      personId: personId,
      sectionIds: this.state.secArr
    }
    if (this.state.userSections.length == '0') {
      message.error('حداقل یک واحد سازمانی وارد شود')
    } else {
      http.post(`${USER_MANAGE.USER_MANAGE_EDIT_TMS_SECTION}`, data, {}).then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          message.success('واحد سازمانی کاربر ویرایش شد')
          this.setState({
            modalSection: !this.state.modalSection
          })
          // alert(JSON.stringify(response.data))
        }
      })
    }
  }

  changeSection = (userSections) => {
    var wareCode = []
    this.setState({userSections})

    // alert(JSON.stringify(selectedOption))
    console.log(`Option selected:`, userSections)

    for (let prop of userSections) {
      wareCode.push(prop.id)
      this.setState({
        secArr: wareCode
      })
      sessionStorage.setItem('wareCode', JSON.stringify(wareCode))
    }
  }

  onResultFetched(data) {
    this.setState({
      Drivers: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Drivers: data,
      DriversCount: sessionStorage.getItem('countAll')
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    var active = $('#active').val()
    var block = $('#block').val()
    var firstname = $('#firstname').val()
    var lastname = $('#lastname').val()
    var username = $('#username').val()
    var mobile = this.convertDigit($('#mobile').val())
    var phone = this.convertDigit($('#phone').val())
    var internalNumber = this.convertDigit($('#internalNumber').val())
    var gender = $('#gender').val()
    var nationalId = this.convertDigit($('#nationalId').val())
    var email = $('#email').val()
    var father = $('#father').val()
    var address = $('#address').val()
    var zipCode = this.convertDigit($('#zipCode').val())

    var roleId = sessionStorage.getItem('roleId')
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    sessionStorage.setItem(
      'params',
      `internalNumber=${internalNumber}&active=${active}&block=${block}&firstname=${firstname}&lastname=${lastname}&username=${username}&mobile=${mobile}&phone=${phone}&gender=${gender}&nationalId=${nationalId}&email=${email}&father=${father}&address=${address}&zipCode=${zipCode}&roleId=${roleId}`
    )

    http
      .get(
        `${
          USER_REPORT.USER_REPORT_OPERATOR
        }?export=false&pageSize=10&pageNumber=1&active=${active}&block=${block}&firstname=${firstname}&lastname=${lastname}&username=${username}&mobile=${mobile}&phone=${phone}&gender=${gender}&nationalId=${nationalId}&email=${email}&father=${father}&address=${address}&zipCode=${zipCode}&roleId=${roleId}&internalNumber=${internalNumber}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable').fadeIn()

          this.setState({
            Drivers: response.data.object.result,
            DriversCount: response.data.object.countAll
          })
        } else {
          $('.showBaseTable').fadeOut()
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  printTable = () => {
    var active = $('#active').val()
    var block = $('#block').val()
    var firstname = $('#firstname').val()
    var lastname = $('#lastname').val()
    var username = $('#username').val()
    var mobile = this.convertDigit($('#mobile').val())
    var internalNumber = this.convertDigit($('#internalNumber').val())
    var phone = this.convertDigit($('#phone').val())
    var gender = $('#gender').val()
    var nationalId = this.convertDigit($('#nationalId').val())
    var email = $('#email').val()
    var father = $('#father').val()
    var address = $('#address').val()
    var zipCode = this.convertDigit($('#zipCode').val())
    sessionStorage.setItem(
      'params',
      `internalNumber=${internalNumber}&active=${active}&block=${block}&firstname=${firstname}&lastname=${lastname}&username=${username}&mobile=${mobile}&phone=${phone}&gender=${gender}&nationalId=${nationalId}&email=${email}&father=${father}&address=${address}&zipCode=${zipCode}`
    )

    http
      .get(`${USER_REPORT.USER_REPORT_OPERATOR}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(response.data))

          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportExcel = () => {
    http
      .get(
        `${USER_REPORT.USER_REPORT_OPERATOR}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${USER_REPORT.USER_REPORT_OPERATOR}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let status = sessionStorage.getItem('active')
    let blockStatus = sessionStorage.getItem('block')
    let fullName = sessionStorage.getItem('fullName')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    const role = this.props.match.params.role || ''
    const {DriversCount, roleCategorys} = this.state
    let excelColumns = [
      {title: 'نام', value: 'firstname'},
      {title: 'نام خانوادگی', value: 'lastname'},
      {title: 'موبایل', value: 'mobile'},
      {title: 'نام کاربری', value: 'username'}
    ]
    let printCol = ['ردیف', 'نام', 'موبایل', 'شماره داخلی', 'نام کاربری', 'وضعیت فعال', 'وضعیت بلاک']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست اپراتور ها"
              headerColSpan={7}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={2}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((operators, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{operators.firstname + ' ' + operators.lastname}</td>
                  <td>{operators.mobile}</td>
                  <td>{operators.internalNumber}</td>
                  <td>{operators.username}</td>
                  <td>
                    <p>{operators.active ? 'فعال' : 'غیر فعال'}</p>
                  </td>
                  <td>
                    <p>{operators.block ? 'بلاک' : 'خارج از بلاک'}</p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="لیست اپراتور.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'firstname'}
                field={'firstname'}
                title={'نام'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'lastname'}
                field={'lastname'}
                title={'نام خانوادگی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'mobile'}
                field={'mobile'}
                title={'موبایل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'username'}
                field={'username'}
                title={'نام کاربری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'internalNumber'}
                field={'internalNumber'}
                title={'شماره داخلی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>کاربران</li>
            <li>اپراتور ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/AddUser"
                  printUrl=""
                  url={USER_REPORT.USER_REPORT_OPERATOR}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  extraParams={role ? `&roleId=${role}` : ''}
                  execelUrl={USER_REPORT.USER_REPORT_OPERATOR + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd="افزودن کاربر"
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>نام</label>
                  <input className="form-control" id="firstname" type="text" />
                </div>
                <div className="formComponent">
                  <label>نام خانوادگی</label>
                  <input className="form-control" id="lastname" type="text" />
                </div>
                <div className="formComponent">
                  <label>نام کاربری</label>
                  <input className="form-control" id="username" type="text" />
                </div>
                <div className="formComponent">
                  <label>بلاک</label>
                  <select id="block" className="form-control">
                    <option value="">------</option>
                    <option value={0}>خارج از بلاک</option>
                    <option value={1}>بلاک</option>
                  </select>
                </div>
                <div className="formComponent">
                  <label>فعال</label>
                  <select id="active" className="form-control">
                    <option value="">------</option>

                    <option value={0}>غیر فعال</option>
                    <option value={1}>فعال</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>تلفن</label>
                  <input className="form-control" id="phone" type="text" />
                </div>

                <div className="formComponent">
                  <label>موبایل</label>
                  <input className="form-control" id="mobile" type="text" />
                </div>
                <div className="formComponent">
                  <label>شماره داخلی</label>
                  <input className="form-control" id="internalNumber" type="text" />
                </div>
                <div className="formComponent">
                  <label>کد ملی</label>
                  <input className="form-control" id="nationalId" type="text" />
                </div>
                <div className="formComponent">
                  <label>ایمیل</label>
                  <input className="form-control" id="email" type="email" />
                </div>
                <div className="formComponent">
                  <label>نام پدر</label>
                  <input className="form-control" id="father" type="text" />
                </div>
                <div className="formComponent">
                  <label>کد پستی</label>
                  <input className="form-control" id="zipCode" type="text" />
                </div>
                <div className="formComponent">
                  <label>آدرس</label>
                  <input className="form-control" id="address" type="text" />
                </div>
                <div className="formComponent">
                  <label>جنسیت</label>
                  <select id="gender" className="form-control">
                    <option value="">------</option>
                    <option value={'man'}>مرد</option>
                    <option value={'woman'}>زن</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="printSection">
              <table className="printTable" ref={(node) => (this.printPart = node)}>
                <tbody>
                  <tr>
                    <td>ردیف</td>
                    <td>نام</td>
                    <td>موبایل</td>
                    <td>شماره داخلی</td>
                    <td>نام کاربری</td>

                    <td>فعال</td>
                    <td>بلاک</td>
                  </tr>
                  {this.state.printInfo.map((operators, index) => (
                    <tr key={'i' + index}>
                      <td>{index + 1}</td>
                      <td>{operators.firstname + ' ' + operators.lastname}</td>
                      <td>{operators.mobile}</td>
                      <td>{operators.internalNumber}</td>
                      <td>{operators.username}</td>
                      <td>
                        <p>{operators.active ? 'فعال' : 'غیر فعال'}</p>
                      </td>
                      <td>
                        <p>{operators.block ? 'بلاک' : 'خارج از بلاک'}</p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام</td>
                    <td>موبایل</td>
                    <td>شماره داخلی</td>
                    <td>نام کاربری</td>
                    <td>فعال</td>
                    <td>بلاک</td>
                    <td>ویرایش</td>
                    <td>ویرایش نقش</td>
                    <td>ویرایش واحد سازمان</td>
                    <td>ویرایش فرایند های کاربر</td>
                    <td>ریست کلمه عبور</td>
                    <td>حذف</td>
                  </tr>
                  {this.state.Drivers.map((operators, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{operators.firstname + ' ' + operators.lastname}</td>
                      <td>{operators.mobile}</td>
                      <td>{operators.internalNumber}</td>
                      <td>{operators.username}</td>
                      <td>
                        <button
                          onClick={() => this.openActivate(index)}
                          style={{visibility: operators.personId === -1 ? 'hidden' : 'visible'}}
                        >
                          {operators.active ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => this.openBlock(index)}
                          style={{visibility: operators.personId === -1 ? 'hidden' : 'visible'}}
                        >
                          {operators.block ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <Link to={`/editInfoUsers/${operators.personId}`} id={`editImage${index}`}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        <button
                          id={`c${index}`}
                          onClick={() => this.openEditRole(index)}
                          style={{visibility: operators.personId === -1 ? 'hidden' : 'visible'}}
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button
                          id={`c${index}`}
                          onClick={() => this.openEditSection(index)}
                          style={{visibility: operators.personId === -1 ? 'hidden' : 'visible'}}
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button
                          id={`c${index}`}
                          onClick={() => this.openEditProcess(index)}
                          style={{visibility: operators.personId === -1 ? 'hidden' : 'visible'}}
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button
                          to="/EditCar"
                          id={`reset${index}`}
                          onClick={() => this.openReset(index)}
                          style={{visibility: operators.personId === -1 ? 'hidden' : 'visible'}}
                        >
                          <img src={require('../../image/reset.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => this.deleteDriver(index)}
                          style={{visibility: operators.personId === -1 ? 'hidden' : 'visible'}}
                        >
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                  <Modal isOpen={this.state.modalActivate} toggle={this.toggleActivate} size="sm">
                    <ModalHeader toggle={this.toggleActivate}>
                      {status == 'activate' ? 'غیر فعالسازی کاربر' : 'فعالسازی کاربر'}
                    </ModalHeader>
                    <ModalBody>
                      <p className="titleSm">
                        {status == 'activate' ? 'علت غیر فعال سازی کاربر چیست' : 'علت فعال سازی کاربر چیست'}
                      </p>
                      <select className="form-control">
                        <option value="1">اقدام ادمین</option>
                      </select>
                    </ModalBody>
                    <ModalFooter>
                      <button className="confirmBtnModal" onClick={this.ConfirmActivate.bind(this)}>
                        اعمال
                      </button>
                      <button className="cancelBtnModal" onClick={this.cancelActivate}>
                        لغو
                      </button>
                    </ModalFooter>
                  </Modal>
                  <Modal isOpen={this.state.modalReset} toggle={this.toggleReset} size="sm">
                    <ModalHeader toggle={this.toggleReset}>نوسازی کلمه عبور کاربر</ModalHeader>
                    <ModalBody>
                      <div className="modalForm">
                        <label htmlFor="password"> کلمه عبور جدید برای {fullName}</label>
                        <input type="password" id="password" name="password" className="form-control" />
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button className="confirmBtnModal" onClick={this.confirmReset.bind(this)}>
                        نوسازی
                      </button>
                      <button className="cancelBtnModal" onClick={this.cancelReset}>
                        لغو
                      </button>
                    </ModalFooter>
                  </Modal>
                  <Modal isOpen={this.state.modalBlock} toggle={this.toggleBlock} size="sm">
                    <ModalHeader toggle={this.toggleBlock}>
                      {blockStatus == 'activate' ? 'خروج از بلاک کاربر' : 'بلاک کردن کاربر'}
                    </ModalHeader>
                    <ModalBody>
                      <p className="titleSm">
                        {blockStatus == 'activate' ? 'علت خروج از بلاک کاربر چیست؟' : 'علت  بلاک کاربر چیست؟'}
                      </p>
                      <select className="form-control">
                        <option value="1">اقدام ادمین</option>
                      </select>
                    </ModalBody>
                    <ModalFooter>
                      <button className="confirmBtnModal" onClick={this.ConfirmBlock.bind(this)}>
                        اعمال
                      </button>
                      <button className="cancelBtnModal" onClick={this.cancelBlock}>
                        لغو
                      </button>
                    </ModalFooter>
                  </Modal>
                  <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
                    <ModalHeader toggle={this.deleteCancel}>حذف اپراتور</ModalHeader>
                    <ModalBody>
                      <p className="titleSm"> علت حذف {fullName} ؟؟؟</p>
                      <select className="form-control">
                        <option value="1">اقدام ادمین</option>
                      </select>
                    </ModalBody>
                    <ModalFooter>
                      <button className="confirmBtnModal" onClick={this.deleteOk}>
                        حذف اپراتور
                      </button>
                      <button className="cancelBtnModal" onClick={this.deleteCancel}>
                        لغو
                      </button>
                    </ModalFooter>
                  </Modal>
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={DriversCount}
                  urlParams={role ? `roleId=${role}` : ''}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={USER_REPORT.USER_REPORT_OPERATOR}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalRole} toggle={this.cancelRole} size="sm">
          <ModalHeader toggle={this.deleteCancel}>نقش اپراتور</ModalHeader>
          <ModalBody>
            <p className="titleSm"> ویرایش نقش {fullName} </p>
            <Select
              value={roleCategorys}
              onChange={this.handleChange}
              options={this.state.roles}
              isMulti={true}
              placeholder=""
            />
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editRole}>
              ویرایش نقش اپراتور
            </button>
            <button className="cancelBtnModal" onClick={this.cancelRole}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalSection} toggle={this.cancelSection} size="sm">
          <ModalHeader toggle={this.cancelSection}>واحد سازمانی اپراتور</ModalHeader>
          <ModalBody>
            <p className="small text-center font-weight-bold"> ویرایش واحد سازمانی {fullName} </p>
            <Select
              value={this.state.userSections}
              onChange={this.changeSection}
              options={this.state.sections}
              isMulti={true}
              placeholder=""
            />
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editSectionOk}>
              ویرایش واحد سازمانی اپراتور
            </button>
            <button className="cancelBtnModal" onClick={this.cancelSection}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalProcess} toggle={() => this.setState({modalProcess: false})} size="sm">
          <ModalHeader toggle={this.deleteCancel}>فرایند های اپراتور</ModalHeader>
          <ModalBody>
            <p className="titleSm"> ویرایش فرایند های {fullName} </p>
            <Select
              value={this.state.selectedProcess}
              onChange={this.changeOperatorProcess}
              options={this.state.process}
              isMulti={true}
              placeholder=""
            />
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editProcess}>
              ویرایش فرایند اپراتور
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalProcess: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default Operators
